import { useMemo } from "react";

export function useAvatar({ name = "", image = "", size = "md" }) {
  return useMemo(() => {
    const sizeMap = {
      sm: "h-6 w-6 text-xs p-[0.9rem] rounded-xl",
      md: "h-6 w-6 text-xs p-4  rounded-full",
      lg: "h-12 w-12 text-sm  mr-1 rounded-full",
    };

    // Initials
    const initials = name
      ? name?.split(" ")
          .map((n) => `${n.charAt(0)}`)
         
      : "";

    // Background color from hash
    const hashCode = (str) =>
      str?.split("").reduce((acc, char) => char?.charCodeAt(0) + ((acc << 5) - acc), 0);
    const hash = Math.abs(hashCode(name));
    const hue = hash % 360;
    const bgColor = `hsl(${hue}, 50%, 50%)`;

    const avatarClass = `text-white  flex items-center justify-center font-semibold uppercase overflow-hidden ${
      sizeMap[size] || sizeMap.md
    }`;

    return {
      initials,
      bgColor,
      avatarClass,
      image,
      name,
    };
  }, [name, image, size]);
}
